export enum KeyEvents {
  spacebar = ' ',
  enter = 'Enter',
  tab = 'Tab',
  escape = 'Escape'
}
